import React from 'react';
import classNames from 'classnames';
import { t } from 'i18next';
import styles from './SearchBar.module.scss';
import Input from '../../Input/Input';

type Props = {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  debounceMs?: number;
  className?: string;
};

export default function SearchBar({ value, onChange, placeholder, debounceMs = 350, className }: Props) {
  const [local, setLocal] = React.useState(value);
  React.useEffect(() => setLocal(value), [value]);

  React.useEffect(() => {
    const id = setTimeout(() => onChange(local), debounceMs);
    return () => clearTimeout(id);
  }, [local, onChange, debounceMs]);

  return (
    <div className={classNames(className)}>
      <Input
        label={t('general.search_label')}
        type="text"
        icon="search"
        value={local}
        onChange={e => setLocal(e.target.value)}
        placeholder={placeholder || 'Search...'}
        className={styles.input}
        aria-label="Search"
      />
    </div>
  );
}
